import React, {FC, ReactElement} from "react";
import styles from "./Page.module.scss";
import cn from "classnames";

interface PageProps {
  children: ReactElement
  className?: any
}

const Page: FC<PageProps> = (props) => {
    const {className, children} = props;
    const classes = cn(styles.page, {[className]: className});

    return (
        <div className={classes}>
            {children}
        </div>
    );
}

export default Page;